var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "entry-teaser", class: _vm.rootClasses },
    [
      _c(
        "conditional-link",
        {
          staticClass: "u-reset entry-teaser--link",
          attrs: { to: _vm.routerLinkParams }
        },
        [
          _c("div", { staticClass: "entry-teaser--content" }, [
            _c("h3", { staticClass: "u-reset entry-teaser--title" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.shortenedTitle) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "u-reset entry-teaser--bullets" },
              _vm._l(_vm.bulletClasses, function(bulletClass) {
                return _c(
                  "li",
                  {
                    key: bulletClass,
                    staticClass: "entry-teaser--bullet",
                    class: bulletClass
                  },
                  [_c("span", { staticClass: "entry-teaser--bullet-icon" })]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "entry-teaser--arrow" },
            [
              _c("ui-icon", {
                attrs: { symbol: "chevron-right", size: "small" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "trs-delayed-fade-enter" } }, [
            _vm.isActiveEntry
              ? _c("div", { staticClass: "entry-teaser--close" }, [
                  _c(
                    "button",
                    {
                      staticClass: "entry-teaser--close-btn",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.onClose($event)
                        }
                      }
                    },
                    [
                      _c("ui-icon", {
                        attrs: { symbol: "close", size: "medium" }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-800fd460", { render: render, staticRenderFns: staticRenderFns })
  }
}